import { useMutation, useQueryClient } from "@tanstack/react-query";
import { qk } from "#/lib/queryKeys";
import {
  createMedicalConcept,
  MedicalConceptListItem,
} from "#/services/articleOutlines";

type CreateMedicalConceptPayload = {
  name: string;
  concept_type:
    | "disease"
    | "symptom"
    | "treatment"
    | "pathophysiology"
    | "diagnosis"
    | "procedure"
    | "medication"
    | "anatomy"
    | "biomarker"
    | "risk_factor";
  description?: string | null;
  is_active?: boolean;
  icd10_code?: string | null;
};

export function useMedicalConceptMutations() {
  const queryClient = useQueryClient();

  const createConcept = useMutation<MedicalConceptListItem, Error, CreateMedicalConceptPayload>({
    mutationFn: (payload) => createMedicalConcept(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: qk.medicalConceptsList() });
    },
  });

  return {
    createConcept,
  };
}

export default useMedicalConceptMutations;
